<template>
    <div class="content-wrapper">
        <section class="content-header">
            <div class="row">
                <div class="col-xs-6">
                    <h1>Campaign List</h1>
                </div>
                <div class="col-xs-6">
                    <router-link :to="{ name: 'AddCampaignCoupon' }" class="btn btn-sm btn-add">
                        <i class="fa fa-plus-square"></i> Add New Campaign
                    </router-link>
                    <a class="btn btn-sm btn-add refresh" @click="refreshNow">
                        <i class="fa fa-refresh"></i> Refresh
                    </a>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="row form">
                <div class="col-xs-6 col-sm-2 form-group">
                    <select name="status" id="status" v-model="status" class="form-control input-sm select2"
                        @change="filterCampaignList()">
                        <option value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                    </select>
                </div>
                <div class="col-xs-6 col-sm-3 form-group">
                    <input type="text" name="campaign_coupon" id="campaign_coupon" v-model="campaign_coupon"
                        class="form-control input-sm" placeholder="Campaign Name | Coupon Code"
                        @keyup.enter="filterCampaignList()" />
                </div>
                <div class="col-xs-6 col-sm-2 form-group">
                    <select name="limit" id="limit" v-model="display_limit" class="form-control input-sm select2"
                        @change="dopagination(1)">
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div class="col-xs-6 col-sm-2 form-group">
                    <a class="btn btn-sm btn-search" @click="filterCampaignList()">
                        <i class="fa fa-search"></i> Search
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="box" id="pagination">
                        <div class="box-header">
                            <h3 class="box-title">
                                Total : {{ totalData }} Showing {{ displayFrom }} to {{ displayTo }}
                                <span class="pull-right noOfData">{{ totalData }}</span>
                            </h3>
                        </div>
                        <div class="box-body">
                            <div class="table-responsive">
                                <table class="table table-0024 table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th class="tdCenter tdSN">SN</th>
                                            <th class="tdCenter">Campaign Name</th>
                                            <th class="tdCenter">Show As Name</th>
                                            <th class="tdCenter">Website Header Img</th>
                                            <th class="tdCenter">Coupon Code</th>
                                            <th class="tdCenter">Aff Share</th>
                                            <th class="tdCenter">Start At</th>
                                            <th class="tdCenter">End At</th>
                                            <th class="tdCenter">Schedule Status</th>
                                            <th class="tdCenter">Discount</th>
                                            <th class="tdCenter">Status</th>
                                            <th class="tdCenter">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data, index) in campaignList" :key="data.id">
                                            <td class="tdCenter tdSN">{{ parseInt(sl) + index }}</td>
                                            <td class="tdCenter">
                                                <router-link
                                                    :to="{ name: 'CampaignCouponDiscountList', params: { id: data.id } }"
                                                    title="Discount Plans">
                                                    {{ data.name }}
                                                </router-link>
                                            </td>
                                            <td class="tdCenter">{{ data.show_as_name }}</td>
                                            <td class="tdCenter">
                                                <a v-if="data.website_hero_img" :href="data.website_hero_img"
                                                    target="_blank">
                                                    <img class="ad-banner" height="35" :src="data.website_hero_img"
                                                        alt="" />
                                                </a>
                                            </td>
                                            <td class="tdCenter">
                                                <router-link
                                                    :to="{ name: 'CampaignCouponDiscountList', params: { id: data.id } }"
                                                    title="Discount Plans">
                                                    {{ data.coupon_code }}
                                                </router-link>
                                            </td>
                                            <td class="tdCenter">
                                                {{ formatPercent(data.affiliate_share_percent) }}
                                            </td>
                                            <td class="tdCenter">{{ data.start_at }}</td>
                                            <td class="tdCenter">{{ data.end_at }}</td>
                                            <td class="tdCenter">
                                                <span :class="getScheduleStatusClass(data)">
                                                    {{ getScheduleStatus(data) }}
                                                </span>
                                            </td>
                                            <td class="tdCenter">
                                                <router-link
                                                    :to="{ name: 'CampaignCouponDiscountList', params: { id: data.id } }"
                                                    title="Set Discount" class="btn btn-sm btn-payment">
                                                    <span>Set Discount</span>
                                                </router-link>
                                            </td>
                                            <td class="tdCenter">
                                                <span
                                                    :class="data.status == 1 ? 'label label-success' : 'label label-warning'">
                                                    {{ data.status == 1 ? 'Active' : 'Inactive' }}
                                                </span>
                                            </td>
                                            <td class="tdCenter">
                                                <router-link
                                                    :to="{ name: 'EditCampaignCoupon', params: { id: data.id } }"
                                                    class="btn btn-xs btn-success" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                        <tr v-if="totalData == 0">
                                            <td colspan="12" class="tdCenter" style="padding: 30px 0">
                                                <b>No Records Found</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="pagination" v-if="last_page > 1">
                            <a v-if="prev_page_url" href="#" @click.prevent="dopagination(current_page - 1)"
                                class="next">
                                « Previous
                            </a>
                            <span v-else class="disabled">« Previous</span>
                            <span v-for="index in last_page" :key="index">
                                <span class="current" v-if="index == current_page">
                                    {{ index }}
                                </span>
                                <span v-else>
                                    <a href="#" @click.prevent="dopagination(index)">{{ index }}</a>
                                </span>
                            </span>
                            <a v-if="next_page_url" href="#" @click.prevent="dopagination(current_page + 1)"
                                class="next">
                                Next »
                            </a>
                            <span v-else class="disabled">Next »</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "CampaignCouponList",
    data() {
        return {
            campaignList: [],
            displayFrom: 0,
            displayTo: 0,
            display_limit: 25,
            totalData: 0,
            prev_page_url: false,
            next_page_url: false,
            last_page: 1,
            current_page: 1,
            sl: 1,
            status: "",
            campaign_coupon: "",
        };
    },
    mounted() {
        $(".select2").select2();
    },
    created() {
        this.com_user_type_access([0, 5, 6, 7], true);
        this.filterCampaignList();
    },
    methods: {
        dopagination(page_no = 1) {
            loader.show();
            let querystr = "paginate=" + this.display_limit;

            if (this.status !== "") {
                querystr += "&status=" + this.status;
            }
            if (this.campaign_coupon) {
                querystr += "&name=" + this.campaign_coupon;
                querystr += "&coupon_code=" + this.campaign_coupon;
            }
            if (page_no > 0) {
                querystr += "&page=" + page_no;
            }

            axios
                .get("/campaigns?" + querystr)
                .then((response) => {
                    this.populateCampaignListData(response);
                    loader.hide();
                })
                .catch((error) => {
                    console.log(error);
                    loader.hide();
                    this.com_errorHandel(error);
                });
        },
        populateCampaignListData(response) {
            this.sl = parseInt(response.data.from) || 1;
            this.campaignList = response.data.data;
            this.totalData = response.data.total;
            this.displayFrom = response.data.from;
            this.displayTo = response.data.to;
            this.display_limit = response.data.per_page;
            this.prev_page_url = response.data.prev_page_url;
            this.next_page_url = response.data.next_page_url;
            this.last_page = response.data.last_page;
            this.current_page = response.data.current_page;
        },
        filterCampaignList() {
            this.dopagination(1);
        },
        refreshNow() {
            this.status = "";
            this.campaign_coupon = "";
            this.display_limit = 25;
            this.filterCampaignList();
        },
        formatPercent(value) {
            if (!value) return "0.00 %";
            return parseFloat(value).toFixed(2) + " %";
        },
        getScheduleStatus(data) {
            const now = new Date();
            const startAt = new Date(data.start_at);
            const endAt = new Date(data.end_at);

            if (now > endAt) {
                return "Finished";
            } else if (now < startAt) {
                return "Not Started Yet";
            } else {
                return "Running";
            }
        },
        getScheduleStatusClass(data) {
            const now = new Date();
            const startAt = new Date(data.start_at);
            const endAt = new Date(data.end_at);

            if (now > endAt) {
                return "label label-danger";
            } else if (now < startAt) {
                return "label label-info";
            } else {
                return "label label-success";
            }
        },
    },
};
</script>

<style scoped></style>